<head>
  <meta charset="UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  <title>Confirmación de Datos</title>
</head>

<body>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-6">
        <div class="container-custom">
          <h4 class="text-center">Confirma tus datos</h4>
          <div class="card-details">
            <!-- <p *ngIf="!this.phoneNumber"><strong>Teléfono:</strong> {{ phoneNumber }}</p> -->
            <p>
              <strong>Número de tarjeta:</strong>
              {{ formattedMaskedValue }}
            </p>
            <p>
              <strong>Vencimiento:</strong>
              {{ expiryDate }}
            </p>
          </div>
          <button class="btn btn-continue btn-block" (click)="triggerAction(true)">
            Continuar
          </button>
          <a (click)="triggerAction(false)" class="btn-back">Cambiar datos de tarjeta</a>
          @if (error) {
            <div class="text-center">
              <label class="mt-3 text-danger">Error en el proceso de pago</label>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</body>
